import axios from "axios";
import { API_URL } from "../config/constants"; // You can keep this if necessary
import { store } from "../store/store"; // Import your Redux store
import { logout } from "../store/slice/authSlice";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a response interceptor (same as before)
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response.status === 401) {
      // If the user is not authenticated, redirect to login page
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);
// Add a request interceptor
axiosInstance.interceptors.request.use(
  (req) => {
    const state = store.getState(); // Access the current Redux state

    console.log("state ==========>", state);

    const token = state?.auth?.user?.authToken; // Assuming the token is stored in 'auth.accessToken'

    if (token) {
      req.headers.Authorization = `Bearer ${token}`; // Set the token in the Authorization header
    }

    return req;
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);
// set
export const setAuthToken = (token) => {
  // Dynamically set the Authorization header if a token exists
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};

export default axiosInstance;
